export default __webpack_public_path__ + "static/media/approved.1bd4595b.svg";